import routes from "../../AppRoutes/routes.json";
import { CommonSetupActions } from "../../Slices/Commonslice";
import { getProductAppData } from "../ProductPages/ProductDisplay/GearBoxAction";
import { ApiLink } from "../Utils/Apilink";

// import {showLoader, hideLoader} from "../../Slices/Commonslice";

export const searchProduct = (
  selectedProduct,
  navigate,
  setSearcheddata,
  setLoading,
  onSearchComplete,
  setOpenModal,
  location
) => {
  return (dispatch, getState) => {
    // dispatch(CommonSetupActions.showLoader());
    try {
      if (setOpenModal) {
        setOpenModal(true);
      }
      
      if (selectedProduct.type !== "VIN" && selectedProduct.type !== "Part Numbers") {
        // const ngLink = 'https://acd000106e65.ngrok-free.app/api/'; Part Numbers
        fetch(ApiLink + "StatisticsAppCrossRef", {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            // 'ngrok-skip-browser-warning':true
          },
          body: JSON.stringify({
            lookup_flag: "keyword",
            request_type: "website",
          }),
        });
      } else if (selectedProduct.type === "Part Numbers") {
        fetch(ApiLink + "StatisticsAppCrossRef", {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            // 'ngrok-skip-browser-warning':true
          },
          body: JSON.stringify({
            lookup_flag: "part",
            request_type: "website",
          }),
        });
      }

      dispatch(CommonSetupActions.setProductlistMessage(false));
      dispatch(CommonSetupActions.setProductList());
      dispatch(CommonSetupActions.setSelectedPart({}));
      dispatch(CommonSetupActions.setQuallifierCollection({}));
      dispatch(CommonSetupActions.setSubModel({}));
      dispatch(CommonSetupActions.setProductList({}));
      dispatch(CommonSetupActions.setRadioValue(null));
      dispatch(CommonSetupActions.setCurrentSelectedYear(null));
      dispatch(CommonSetupActions.setCurrentSelectedEngine(""));
      dispatch(CommonSetupActions.setCurrentSelectedMake(""));
      dispatch(CommonSetupActions.setCurrentSelectedModel(""));
      dispatch(CommonSetupActions.setCurrentSelectedSubModelValue(null));
      dispatch(CommonSetupActions.setSelectedInterchange([]));
      const product = getState().CommonStore.selectedProduct;

      // const baseVehicleID=
      setLoading(true);
      if (
        selectedProduct.type === "Applications" ||
        selectedProduct.type === "VIN"
      ) {
        let baseVehicleID =
          selectedProduct.type === "VIN"
            ? selectedProduct.value.split("!!")[0]
            : selectedProduct.value.split("===")[0];
        let engineID =
          selectedProduct.type === "VIN"
            ? selectedProduct.value.split("!!")[1]
            : selectedProduct.id.split("!")[3];

        fetch(
          `${ApiLink}qualifierCollection/${baseVehicleID}/${engineID}/noqualifier/0/0`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              // "ngrok-skip-browser-warning": "true",
            },
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((res) => {
            setLoading(false);
            if (res === "fail") {
              sessionStorage.clear();
              // navigate(routes.Ecatlog);
              dispatch(
                getProductList(
                  ApiLink,
                  baseVehicleID,
                  engineID,
                  "noqualifier",
                  "noqualifier",
                  onSearchComplete,
                  setOpenModal,
                  navigate
                )
              );
            } else {
              if (res.values.length === 1) {
                fetch(
                  `${ApiLink}qualifierCollection/${baseVehicleID}/${engineID}/${res.values[0].id}/0/0`,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json; charset=utf-8",
                      // "ngrok-skip-browser-warning": "true",
                    },
                  }
                )
                  .then((response12) => {
                    return response12.json();
                  })
                  .then((res1) => {
                    if (res1 === "fail") {
                      navigate(routes.Ecatlog);
                      dispatch(
                        getProductList(
                          ApiLink,
                          baseVehicleID,
                          engineID,
                          "noqualifier",
                          "noqualifier",
                          onSearchComplete,
                          setOpenModal,
                          navigate
                        )
                      );
                    } else {
                      dispatch(CommonSetupActions.setSubModel(res1));
                      navigate(routes.Ecatlog);
                      if (setOpenModal) {
                        setOpenModal(false);
                      }
                    }
                  });
              } else {
                dispatch(CommonSetupActions.setQuallifierCollection(res));
                sessionStorage.clear();
                navigate(routes.Ecatlog);
              }
              dispatch(CommonSetupActions.setQuallifierCollection(res));
              if (setOpenModal) setOpenModal(false);
            }
            // setSearcheddata([]);
          });
      } else {
        if (selectedProduct.id === "partintnumber") {
          var splitValue = selectedProduct.value.split("===");
          var val1 = splitValue[0];
          var val2 = splitValue[1];
          fetch(`${ApiLink}partInterchangeResponse/${val1}/${val2}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              // "ngrok-skip-browser-warning": "true",
            },
          })
            .then((responsee) => {
              return responsee.json();
            })
            .then((ress) => {
              dispatch(CommonSetupActions.setSelectedInterchange(ress));
              dispatch(CommonSetupActions.setSelectedPart(ress.res[0]));
              setLoading(false);
               if (setOpenModal) {
                setOpenModal(false);
               }
               if (location.pathname === "/home") {
                navigate(routes.Ecatlog);
               } 
            });
        } else {
          fetch(`${ApiLink}premiumCollection/${selectedProduct.label}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              // "ngrok-skip-browser-warning": "true",
            },
          })
            .then((responsee) => {
              return responsee.json();
            })
            .then((ress) => {
              setLoading(false);
              dispatch(CommonSetupActions.setSelectedPart(ress[0]));

              dispatch(
                getProductAppData(
                  selectedProduct.label,
                  navigate,
                  selectedProduct,
                  ress[0].ymm,
                  setOpenModal
                )
              );
            });
        }
      }
    } catch (err) {
    } finally {
      // dispatch(CommonSetupActions.hideLoader());
    }
  };
};

export const getProductList = (
  link,
  baseVehicleID,
  engineID,
  qualifier_id,
  qualifier_name,
  onSearchComplete,
  setOpenModal,
  navigate
) => {
  return (dispatch, getState) => {
    if (setOpenModal) setOpenModal(true);
    try {
      dispatch(CommonSetupActions.setProductlistMessage(false));

      let selectedProduct = getState().CommonStore.selectedProduct;
      let top25flag;
      let lookup_flag;
      let label;

      if (selectedProduct.type === "VIN") {
        const parts = selectedProduct.value.split("!!");
        label = parts[5] + " " + parts[3] + " " + parts[4] + " " + parts[2]+"L";
        lookup_flag = "vin";
        top25flag = "";
      } else {
        label = getState().CommonStore.selectedProduct.label;
        lookup_flag = "";
        top25flag = "application";
      }

      // const ngLink = 'https://acd000106e65.ngrok-free.app/api/';
      fetch(link + "StatisticsAppCrossRef", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          // 'ngrok-skip-browser-warning':true
        },
        body: JSON.stringify({
          label: label,
          lookup_flag: lookup_flag,
          top25flag: top25flag,
          request_type: "website",
        }),
      });

      fetch(
        `${link}websiteProductList/${baseVehicleID}/${engineID}/${qualifier_id}/${qualifier_name}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            // "ngrok-skip-browser-warning": "true",
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (setOpenModal) {
            setOpenModal(false);
          }
          dispatch(CommonSetupActions.setProductlistMessage(true));
          dispatch(CommonSetupActions.setProductList(res.partTypeArray));
          navigate(routes.Ecatlog, {
            state: { baseVehicleID: baseVehicleID, engineID: engineID },
          });
          if (onSearchComplete) {
            onSearchComplete();
          }
        })
        .catch((err) => console.log(err));
    } catch (err) {}
  };
};
